import { useFretboardConfigStore } from '@/features/fretboard-base';
import React from 'react';

interface FretNumberSelectorProps {
  minFrets?: number;
  maxFrets?: number;
  step?: number;
}

export const FretNumberSelector: React.FC<FretNumberSelectorProps> = ({
  minFrets = 2,
  maxFrets = 24,
  step = 1,
}) => {
  const numFrets = useFretboardConfigStore((state) => state.numFrets);
  const setNumFrets = useFretboardConfigStore((state) => state.setNumFrets);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newNumFrets = parseInt(e.target.value, 10);
    if (!isNaN(newNumFrets)) {
      setNumFrets(Math.max(minFrets, Math.min(maxFrets, newNumFrets)));
    }
  };

  return (
    <div className="form-control w-full mb-3 max-w-full">
      <label className="label">
        <span className="label-text">Number of Frets</span>
        <span className="label-text-alt">{numFrets} frets</span>
      </label>
      <div className="flex gap-3 items-center">
        <input
          type="range"
          className="range range-primary flex-grow"
          value={numFrets}
          onChange={handleChange}
          min={minFrets}
          max={maxFrets}
          step={step}
        />
        <input
          type="number"
          className="input input-bordered input-sm w-20 min-w-18"
          value={numFrets}
          onChange={handleChange}
          min={minFrets}
          max={maxFrets}
          step={step}
        />
      </div>
    </div>
  );
};
